import { IDomains, IDomainConcept } from 'Modules/Studio/constants/Domains/domains.interface';

export type TConceptsMap = Record<string, IDomainConcept>;

export type TConceptsMapAndSupers = {
  conceptsMap: TConceptsMap; // Map of concepts keyed by their URI
  superClassMap: Record<string, boolean>; // Map of inherited concepts keyed by their URI
};

/**
 * This function takes an array of domains and returns a map of concepts
 * and a map of super classes. The conceptsMap contains the concepts
 * keyed by their URI, and the superClassMap contains the inherited concepts
 * keyed by their URI with a boolean value indicating their inheritance.
 * @param domains
 * @returns conceptsMapType
 */
export const getDomainConceptsMap = (domains: IDomains[]): TConceptsMapAndSupers => {
  return domains.reduce(
    (acc, domain) => {
      const maps = domain.concepts.reduce(
        (conceptAcc, concept) => {
          return {
            ...conceptAcc,
            conceptsMap: {
              ...conceptAcc.conceptsMap,
              [concept.uri]: concept,
            },
            superClassMap: {
              ...conceptAcc.superClassMap,
              ...concept.inheritedConcepts.reduce(
                (i, inheritedConcept) => ({ ...i, [inheritedConcept]: true }),
                {}
              ),
            },
          };
        },
        { conceptsMap: acc.conceptsMap, superClassMap: acc.superClassMap }
      );

      return {
        ...acc,
        conceptsMap: maps.conceptsMap,
        superClassMap: maps.superClassMap,
      };
    },
    { conceptsMap: {}, superClassMap: {} }
  );
};
